import { Builder } from '@builder.io/react';

import SectionTitle from './index';

Builder.registerComponent(SectionTitle, {
  name: 'SectionTitle',
  inputs: [
    {
      name: 'overtitle',
      type: 'string'
    },
    {
      name: 'title',
      type: 'string'
    },
    {
      name: 'product',
      type: 'string'
    },
    {
      name: 'subtitle',
      type: 'string'
    },
    {
      name: 'marginBottom',
      type: 'boolean'
    },
    {
      name: 'centered',
      type: 'boolean'
    },
    {
      name: 'link',
      type: 'object',
      subFields: [
        {
          name: 'text',
          type: 'string'
        },
        {
          name: 'href',
          type: 'url'
        }
      ]
    },
    {
      name: 'theme',
      type: 'string',
      defaultValue: 'dark',
      enum: ['dark', 'light']
    },
    {
      name: 'themeColors',
      type: 'object',
      subFields: [
        {
          name: 'overtitleColor',
          type: 'string'
        }
      ]
    }
  ]
});
